import { enableProdMode, Injector } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from '@app/app.module';
import { environment } from '@environments/environment';
import { translations } from '@aws-amplify/ui-angular';
import awsmobile from 'src/aws-exports';
import { Amplify, I18n } from '@aws-amplify/core';
import { Auth } from '@aws-amplify/auth';
import amplify_hun from 'src/assets/i18n/amplify_hu.json';
import SwiperCore, { Autoplay, Pagination, Navigation } from 'swiper';

let appInjectorRef: Injector;
export const appInjector = (injector?: Injector): Injector => {
  if (injector) {
    appInjectorRef = injector;
  }

  return appInjectorRef;
};

Amplify.configure(awsmobile);
Auth.configure(awsmobile);

I18n.putVocabularies({
  ...translations,
  hu: amplify_hun,
});

SwiperCore.use([Pagination, Autoplay, Navigation]);

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then((appRef) => {
    appInjector(appRef.injector); // store a reference to the application injector
  })
  .catch((err) => console.error(err));
